import styled, { keyframes, css } from 'styled-components';
import Colors from 'library/constants/colors';
import { IconPencil } from 'library/styles/icon';
import { Container as Color } from 'library/components/color/styles';
import { InputText } from 'library/styles/text';
import { ShadowSlight } from '../../../constants/styles-config';

const load = keyframes`
  0% {
    transform: rotate(0);
    color: ${Colors.shade08};
  }
  50% {
    transform: rotate(180deg);
    color: ${Colors.shade08};
  }
  100% {
    transform: rotate(360deg);
    color: ${Colors.shade08};
  }
`;

export const Icon = styled(IconPencil)`
  z-index: 11;
  top: 10px;
  font-size: ${({ size = 28 }) => size}px;
  left: 5px;
  animation-name: ${({ isLoading }) => (isLoading ? load : '')};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export const ColorIcon = styled(Icon)`
  //top: calc(50% - 24px);
`;

export const CloseIcon = styled(Icon)`
  right: 5px;
  left: initial;
  cursor: pointer;
  font-weight: 900;
`;

const ItemInputStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  padding-left: 52px;
  margin-bottom: 10px;
  background-color: ${Colors.shade07};
  background-size: 200% 100%;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
`;

export const StyledColors = styled.div`
  ${InputText};
  ${ItemInputStyles};
  box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.shade06)};
  
  ::placeholder {
    color: ${({ progress }) => (progress > 10 ? '#fff' : Colors.shade01)};
  };
  
  &:focus:not(:read-only) {
    box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.violet)};
    outline: none;
  }

  ${({ readOnly, disabled }) => {
    if (readOnly) {
      return `{
        outline: none;
        background-image: linear-gradient(to right, #fff 50%, ${Colors.violet} 50%);
        background-position: ${({ progress }) => (progress > 0 ? `-${progress}% 0;` : 'inherit')};
        transition: ${({ progress }) => (progress ? 'all 0.5s linear' : 'none')};
        color: ${({ progress }) => (progress > 20 ? '#fff' : Colors.shade01)};
        margin-bottom: 1px;
      }`;
    }

    if (disabled) {
      return `{
        cursor: not-allowed;
        
        ${ColorIcon} {
          color: ${Colors.shade04};
        }
      }`;
    }
    return '';
  }}
  
  ${({ readOnly, hasError, disabled }) => {
    if (!readOnly && !disabled) {
      return `
        &:hover {
          box-shadow: 0 2px 0 ${hasError ? Colors.error : Colors.shade04}
        }`;
    }
    return '';
  }}

  ${Color} {
    margin-right: 4px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;

export const StyledInput = styled.input`
  ${InputText};
  ${ItemInputStyles};
  box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.shade06)};
  -moz-user-select: ${({ focusDisabled }) => (focusDisabled ? 'none' : 'auto')};
  -webkit-user-select: ${({ focusDisabled }) => (focusDisabled ? 'none' : 'auto')};
  -ms-user-select: ${({ focusDisabled }) => (focusDisabled ? 'none' : 'auto')};
  user-select: ${({ focusDisabled }) => (focusDisabled ? 'none' : 'auto')};
  cursor: ${({ focusDisabled }) => (focusDisabled ? 'not-allowed' : 'default')};

  ::placeholder {
    color: ${Colors.shade02};
  };

  &[type="number"]:read-only {
    &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
      appearance: none;
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:focus:not(:read-only) {
    box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.violet)};
    outline: none;
  }

  :read-only {
    ${({ isFocusDisabled, isLoading }) => (!isFocusDisabled || isLoading) && `
      outline: none;
      background-image: linear-gradient(to right, #fff 50%, ${Colors.violet} 50%);
      background-position: ${({ progress }) => (progress > 0 ? `-${progress}% 0;` : 'inherit')};
      transition: ${({ progress }) => (progress ? 'all 0.5s linear' : 'none')};
      color: ${Colors.shade02};
      margin-bottom: 1px;
    `}


    ::placeholder {
      color: ${Colors.shade02};
    };
  }

  &:hover:not(:read-only) {
    box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.shade04)};
  }
`;

export const Image = styled.div`
  width: 40px;
  height: 40px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${({ url }) => url});
  //filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
`;

export const Container = styled.div`
  display: flex;
  //max-width: 638px;
  width: 100%;
  position: relative;
  flex-direction: column;
  
  ${Icon} {
    // color: ${({ isLoading }) => (isLoading ? Colors.violet : 'initial')};
    animation-name: ${({ isLoading }) => (isLoading ? load : '')};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

export const MoreColors = styled.div`
  text-align: center;
  line-height: 28px;
  min-width: 28px !important;
  width: auto;
  border-radius: 14px;
  height: 28px;
  display: inline-block;
  box-sizing: border-box;
  background-color: ${Colors.shade06};
  color: ${Colors.shade02};
  padding: 0 7px;
`;

export const Progress = styled.span`
  position: absolute;
  top: 18px;
  right: 24px;
  color: ${({ value }) => (value >= 90 ? Colors.shade08 : 'inherit')};
  font-weight: bold;
  display: block;
  z-index: 2;
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  width: 40px;
  min-width: 40px;
  height: 40px;
  margin-right: 20px;
  vertical-align: middle;
  box-shadow: ${ShadowSlight};

  //filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));

  &:hover {
    > div {
      opacity: 1;
    }
  }
`;

export const MoreImagesMarker = styled(ImageWrapper)`
  text-align: center;
  line-height: 32px;
  min-width: 32px !important;
  width: 32px;
  height: 32px;
  display: inline-block;
  box-sizing: border-box;
  background-color: ${Colors.shade06};
  color: ${Colors.shade02};
`;
